import {
  fetchQueueApi,
  fetchQueueAssignmentsApi,
  fetchQueueHistoryApi,
  joinQueueApi,
  leaveQueueApi,
} from 'app/pensieve/queries/enhanced';

function getDispatch() {
  // Lazy require: store imports sagas that import this module.
  return require('app/store').default.dispatch;
}

// RTK Query 1.8 does not write cache when subscribe is false, so unwrap() is undefined.
const refetch = { forceRefetch: true } as const;
// Nothing reads mutation results from the store; tag invalidation still runs untracked.
const untracked = { track: false } as const;

async function unwrapQuery(result: { unwrap: () => Promise<any>; unsubscribe: () => void }) {
  try {
    return await result.unwrap();
  } finally {
    result.unsubscribe();
  }
}

export default {
  async fetchQueue() {
    const data = await unwrapQuery(
      getDispatch()(fetchQueueApi.endpoints.MentorDash_FetchQueue.initiate(undefined, refetch))
    );
    return data.queue;
  },
  async fetchQueueAssignments() {
    const data = await unwrapQuery(
      getDispatch()(fetchQueueAssignmentsApi.endpoints.MentorDash_FetchQueueAssignments.initiate(undefined, refetch))
    );
    return data.queue.assigned;
  },
  async fetchQueueHistory(count: number, afterCursor = '') {
    const data = await unwrapQuery(
      getDispatch()(fetchQueueHistoryApi.endpoints.MentorDash_FetchHistory.initiate({ count, afterCursor }, refetch))
    );
    return data.queue.history;
  },
  async joinQueue(projectIds: string[]) {
    const data = await getDispatch()(
      joinQueueApi.endpoints.MentorDash_JoinQueue.initiate({ projectIds }, untracked)
    ).unwrap();
    return data.queue.enqueue;
  },
  async leaveQueue() {
    const data = await getDispatch()(
      leaveQueueApi.endpoints.MentorDash_LeaveQueue.initiate(undefined, untracked)
    ).unwrap();
    return data.queue.dequeue;
  },
};
